<template>
    <div class="single-product__body-top__item d-md-block">
        <a
            href="javascript:void(0)"
            @click="wishlist"
            class="single-product__body-top__icon"
            :class="{'single-product__body-top__icon___active' : wishlisted}"
            data-bs-toggle="tooltip" title="لیست مورد علاقه"
        >
            <i class="fa fa-heart" v-if="wishlisted"></i>
            <i class="fa fa-heart-o" v-else></i>
        </a>
        <a
            href="javascript:void(0)"
            @click="waitingList"
            class="single-product__body-top__icon"
            :class="{'single-product__body-top__icon___active_blue' : waiting_listed}"
            data-bs-toggle="tooltip" title="لیست انتظار موجودی"
        >
            <i class="fa fa-bell" v-if="waiting_listed"></i>
            <i class="fa fa-bell-o" v-else></i>
        </a>
        <CopyProductUrlButton/>
        <a
            href="javascript:void(0)"
            @click="share"
            class="single-product__body-top__icon"
            data-bs-toggle="tooltip" title="اشتراک گذاری محصول"
        >
            <i class="fa fa-share"></i>
        </a>
    </div>
</template>

<script>
import {ProductMixin} from "./ProductMixin";
import CopyProductUrlButton from "./CopyProductUrlButton.vue";

export default {
    components: {CopyProductUrlButton},
    mixins: [ProductMixin],
    data: () => ({

    }),
    computed: {
        wishlisted() {
            return this.product.is_wishlisted;
        },
        waiting_listed() {
            return this.product.is_waiting_listed;
        }
    },
    methods: {
        async wishlist() {
            if (this.checkIsLoading()) {
                this.startLoading();
                const config = {
                    headers: {
                        Authorization: 'Bearer '+localStorage.getItem('_token')
                    }
                };
                if (this.wishlisted) {
                    await this.axios.delete(this.route('api.profile.wishlist.destroy', [this.product.id]), config)
                        .then(response => {
                            this.product.is_wishlisted = false;
                        })
                        .catch(error => {
                            this.errorToast(null, error);
                        });
                } else {
                    await this.axios.post(this.route('api.profile.wishlist.store', [this.product.id]), {}, config)
                        .then(response => {
                            this.product.is_wishlisted = true;
                        })
                        .catch(error => {
                            this.errorToast(null, error);
                        });
                }
                this.endLoading();
            }
        },
        async waitingList() {
            if (this.checkIsLoading()) {
                this.startLoading();
                const config = {
                    headers: {
                        Authorization: 'Bearer '+localStorage.getItem('_token')
                    }
                };
                if (this.waiting_listed) {
                    await this.axios.delete(this.route('api.profile.waiting-list.destroy', [this.product.id]), config)
                        .then(response => {
                            this.product.is_waiting_listed = false;
                        })
                        .catch(error => {
                            this.errorToast(null, error);
                        });
                } else {
                    await this.axios.post(this.route('api.profile.waiting-list.store', [this.product.id]), {}, config)
                        .then(response => {
                            this.product.is_waiting_listed = true;
                        })
                        .catch(error => {
                            this.errorToast(null, error);
                        });
                }
                this.endLoading();
            }
        },
        copy() {

        },
        share() {

        }
    }
}
</script>

<style scoped>

</style>
